'use client';

import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { SearchReplaceRecommendationsFragmentDoc } from '@packages/gql/generated/shopping/SearchReplaceRecommendationsFragmentDoc';
import { SearchReplaceProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/SearchReplaceProductsRecoSlider';
import { useIntl } from 'react-intl';
import { getSkuPart } from '@packages/modules/src/helpers/getSkuPart/getSkuPart';
import { searchReplaceFallbackHeadline } from './messages';

/* GraphQL */ `
  fragment SearchReplaceRecommendations on Product {
    hasSeries
    orderNumber
    promotion
    sku
  }
`;

export type SearchReplaceProps = {
  /**
   * The data from the product query needed for the `SearchReplaceProductsRecoSlider` component.
   */
  data: FragmentType<typeof SearchReplaceRecommendationsFragmentDoc>;
};

/**
 * This component is a wrapper for the `SearchReplaceProductsRecoSlider` component.
 * It encapsulates the data from the product query needed for the `SearchReplaceProductsRecoSlider` component and passes correct props.
 */
export const SearchReplaceRecommendations = ({ data }: SearchReplaceProps) => {
  const { sku, hasSeries, orderNumber, promotion } = getFragmentData(
    SearchReplaceRecommendationsFragmentDoc,
    data,
  );
  const { formatMessage } = useIntl();

  return (
    <SearchReplaceProductsRecoSlider
      productId={`${orderNumber}${promotion}`}
      size={getSkuPart(sku, 'Size')}
      elementIndex={hasSeries ? 3 : 2}
      fetchOnThreshold
      pageTemplate="detailview"
      title={formatMessage(searchReplaceFallbackHeadline)}
      key={`${orderNumber}${3}`}
    />
  );
};
